/**
 * Result type and application error, per TechSpec §4.2.
 *
 * Domain functions SHOULD return `Result` for expected failures rather than
 * throwing. Unexpected errors bubble to the Fastify error handler.
 */
export const ERROR_CODES = [
    'VALIDATION',
    'UNAUTHORIZED',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'RATE_LIMITED',
    'UPSTREAM_UNAVAILABLE',
    'SERVICE_UNAVAILABLE',
    'INTERNAL',
];
/** Default HTTP status for each error code. */
export const ERROR_CODE_STATUS = {
    VALIDATION: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    RATE_LIMITED: 429,
    UPSTREAM_UNAVAILABLE: 502,
    SERVICE_UNAVAILABLE: 503,
    INTERNAL: 500,
};
export class AppError extends Error {
    code;
    status;
    details;
    constructor(code, message, status = ERROR_CODE_STATUS[code], details) {
        super(message);
        this.code = code;
        this.status = status;
        this.details = details;
        this.name = 'AppError';
    }
    static is(value) {
        return value instanceof AppError;
    }
}
export function ok(value) {
    return { ok: true, value };
}
export function err(error) {
    return { ok: false, error };
}
//# sourceMappingURL=result.js.map